import {
  SEU_COMPONENT_OUTPUT_PLACEHOLDER,
  SeuApiConverter,
  SeuComponentHandle,
  SeuComponentHandleApi,
} from '@seu-types';

export const handlesConverter: SeuApiConverter<
  SeuComponentHandle[],
  SeuComponentHandleApi[]
> = {
  fromApi: (handles) => {
    if (!handles?.length) {
      return [{ id: SEU_COMPONENT_OUTPUT_PLACEHOLDER, values: [] }];
    }
    return handles.map((handle) => ({
      ...handle,
      values: handle.values?.map((value) => ({
        ...value,
        operatingConditionId: String(value.operatingConditionId),
      })),
    }));
  },
  toApi: (handles) => {
    if (
      handles?.length === 1 &&
      handles[0].id === SEU_COMPONENT_OUTPUT_PLACEHOLDER
    ) {
      return [];
    }
    return handles.map((handle) => ({
      ...handle,
      values: handle.values?.map((value) => ({
        ...value,
        value: value.value ?? undefined,
        operatingConditionId: Number(value.operatingConditionId),
        isRemainder: value.isRemainder ?? false,
      })),
    }));
  },
};
